
import moment from 'moment';

const DateCalc = {
  GetDateDiff(startTime,num,diffType) {
        let date;
       // diffType周期单位1：周 2：月 3：年，4：天
       if(diffType == 1){
            date = moment(startTime).add(num, 'weeks').format('YYYY-MM-DD');
       }else if (diffType == 2){
           date = moment(startTime).add(num, 'months').format('YYYY-MM-DD');
       }else if (diffType == 3){
          date = moment(startTime).add(num, 'years').format('YYYY-MM-DD');
       }else if (diffType == 4){
          date = moment(startTime).add(num, 'days').format('YYYY-MM-DD');
       }
       return date+' '+'23:59:59';
 },
};
export default DateCalc



// WEBPACK FOOTER //
// ./src/config/dateCalculate.js